import { useEffect } from 'react';
import { useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { useAgreementsAiSearchStore } from './useAgreementsAiSearchStore';
const errorMessage = (t, errorCode)=>{
    switch(errorCode){
        case 'llm_timeout':
            return t.llmTimeout();
        case 'llm_error':
            return t.llmError();
        case 'llm_invalid_response':
            return t.llmInvalidResponse();
        case 'llm_schema_validation_failed':
            return t.llmSchemaValidationFailed();
        case 'search_failed':
            return t.searchFailed();
        case 'cannot_extract':
            return t.cannotExtract();
        case 'unknown':
            return t.unknown();
    }
};
export const useAgreementsAiSearchErrorToast = (toastTestId)=>{
    const { showErrorToast } = useOverlayContext();
    const { t } = useLocaleKeys('agreement.dashboard.aiSearch.errors');
    const errorCode = useAgreementsAiSearchStore((s)=>s.errorCode);
    const setError = useAgreementsAiSearchStore((s)=>s.setError);
    useEffect(()=>{
        if (errorCode == null) return;
        showErrorToast(errorMessage(t, errorCode), toastTestId);
        setError(null);
    }, [
        errorCode,
        setError,
        toastTestId
    ]);
};
